import { createQueryKeys } from '@lukemorales/query-key-factory'

export const enterprise = createQueryKeys('enterprise', {
  detail: (enterpriseId: number) => [enterpriseId],
  membersSearch: (
    enterpriseId: number,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc',
    limit?: number,
    offset?: number,
    search?: string,
  ) => [enterpriseId, sortBy, sortOrder, limit, offset, search],
  membershipsAndInvitations: (
    enterpriseId: number,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc',
    limit?: number,
    offset?: number,
    query?: string,
  ) => [enterpriseId, sortBy, sortOrder, limit, offset, query],
  invitationsSent: (statusFilter?: string) => [statusFilter],
})
